<template>
  <el-dialog
    v-model="visible"
    :title="dialogTitle"
    :width="dialogWidth"
    :before-close="handleClose"
    destroy-on-close
    append-to-body
  >
    <el-form
      ref="formRef"
      :model="formData"
      :rules="formRules"
      label-width="100px"
      label-position="left"
      status-icon
    >
      <!-- 用户基本信息 -->
      <el-form-item label="用户昵称" prop="nickname">
        <el-input
          v-model="formData.nickname"
          placeholder="请输入用户昵称"
          maxlength="20"
          show-word-limit
        />
      </el-form-item>

      <el-form-item label="微信号" prop="wechatNumber">
        <el-input
          v-model="formData.wechatNumber"
          placeholder="请输入用户微信号"
          maxlength="50"
          show-word-limit
        />
      </el-form-item>

      <el-form-item label="性别" prop="gender">
        <el-radio-group v-model="formData.gender">
          <el-radio label="male">男</el-radio>
          <el-radio label="female">女</el-radio>
          <el-radio label="unknown">未知</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="手机号码" prop="phone">
        <el-input
          v-model="formData.phone"
          placeholder="请输入手机号码"
          maxlength="11"
        />
      </el-form-item>

      <el-form-item label="邮箱地址" prop="email">
        <el-input
          v-model="formData.email"
          placeholder="请输入邮箱地址"
          maxlength="50"
        />
      </el-form-item>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="会员类型" prop="memberType">
            <el-select
              v-model="formData.memberType"
              placeholder="请选择会员类型"
            >
              <el-option
                v-for="type in memberTypes"
                :key="type.value"
                :label="type.label"
                :value="type.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="用户状态" prop="status">
            <el-select
              v-model="formData.status"
              placeholder="请选择用户状态"
            >
              <el-option
                v-for="status in userStatuses"
                :key="status.value"
                :label="status.label"
                :value="status.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="用户余额" prop="balance">
            <el-input-number
              v-model="formData.balance"
              :min="0"
              :precision="2"
              :step="0.01"
              controls-position="right"
              placeholder="请输入用户余额"
              style="width: 200px"
            />
            <span class="score-text">元</span>
          </el-form-item>
        </el-col>
      </el-row>

      <!-- 运动偏好 -->
      <el-divider>运动偏好</el-divider>
      
      <el-form-item label="偏好运动" prop="preferredSports">
        <el-select
          v-model="formData.preferredSports"
          multiple
          filterable
          placeholder="请选择偏好运动"
        >
          <el-option
            v-for="sport in sportTypes"
            :key="sport.value"
            :label="sport.label"
            :value="sport.value"
          />
        </el-select>
      </el-form-item>

      <el-form-item label="运动水平" prop="skillLevel">
        <el-select
          v-model="formData.skillLevel"
          placeholder="请选择运动水平"
        >
          <el-option
            v-for="level in skillLevels"
            :key="level.value"
            :label="level.label"
            :value="level.value"
          />
        </el-select>
      </el-form-item>

      <el-form-item label="可用时间" prop="availableTime">
        <el-select
          v-model="formData.availableTime"
          multiple
          filterable
          placeholder="请选择可用时间"
        >
          <el-option
            v-for="time in availableTimes"
            :key="time.value"
            :label="time.label"
            :value="time.value"
          />
        </el-select>
      </el-form-item>

      <el-form-item label="活跃度分数" prop="activityScore">
        <el-input-number
          v-model="formData.activityScore"
          :min="0"
          :max="100"
          :precision="0"
          :step="1"
          controls-position="right"
          placeholder="请输入活跃度分数"
          style="width: 200px"
        />
        <span class="score-text">%</span>
        <el-button 
          v-if="mode === 'edit'" 
          type="primary" 
          size="small" 
          @click="calculateActivityScore"
          style="margin-left: 10px"
          :loading="loading"
        >
          自动计算
        </el-button>
        <el-button 
          v-if="mode === 'edit'" 
          type="info" 
          size="small" 
          @click="getActivityScore"
          style="margin-left: 10px"
        >
          查看当前分数
        </el-button>
      </el-form-item>

      <el-form-item label="创建活动数" prop="createdActivities">
        <el-input-number
          v-model="formData.createdActivities"
          :min="0"
          :step="1"
          placeholder="请输入创建活动数"
        />
      </el-form-item>

      <el-form-item label="参与活动数" prop="joinedActivities">
        <el-input-number
          v-model="formData.joinedActivities"
          :min="0"
          :step="1"
          placeholder="请输入参与活动数"
        />
      </el-form-item>

      <el-form-item label="是否推荐" prop="isRecommended">
        <el-switch
          v-model="formData.isRecommended"
          active-text="推荐用户"
          inactive-text="普通用户"
        />
      </el-form-item>

      <el-form-item label="账号备注" prop="remark">
        <el-input
          v-model="formData.remark"
          type="textarea"
          :rows="2"
          placeholder="请输入账号备注信息"
          maxlength="100"
          show-word-limit
        />
      </el-form-item>

      <!-- 用户积分与荣誉信息 -->
      <el-divider>积分与荣誉</el-divider>
      
      <el-form-item label="用户积分">
        <el-input-number
          v-model="formData.points"
          :min="0"
          :precision="0"
          :step="10"
          controls-position="right"
          placeholder="用户积分"
          style="width: 200px"
          disabled
        />
        <span v-if="formData.pointsLastUpdate" class="update-time">
          最后更新: {{ formatDate(formData.pointsLastUpdate) }}
        </span>
      </el-form-item>

      <el-form-item label="用户荣誉">
        <div class="honors-container" v-if="formData.honors && formData.honors.length > 0">
          <el-tag
            v-for="honor in formData.honors"
            :key="honor.id"
            type="success"
            :closable="false"
            style="margin: 0 8px 8px 0"
          >
            {{ honor.name }} ({{ honor.description }})
          </el-tag>
        </div>
        <div v-else class="no-honors">
          暂无荣誉信息
        </div>
      </el-form-item>
    </el-form>

    <template #footer>
      <span class="dialog-footer">
        <el-button @click="handleClose">取消</el-button>
        <el-button type="primary" @click="handleSubmit" :loading="loading">
          {{ loading ? '提交中...' : '确认' }}
        </el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script>
import { ref, reactive, computed, watch, nextTick } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import api from '@/utils/api'

// 模拟地区数据（实际项目中应该从API获取）
const regionOptions = [
  {
    value: 'beijing',
    label: '北京市',
    children: [
      { value: 'dongcheng', label: '东城区' },
      { value: 'xicheng', label: '西城区' },
      { value: 'chaoyang', label: '朝阳区' },
      { value: 'haidian', label: '海淀区' },
      { value: 'fengtai', label: '丰台区' }
    ]
  },
  {
    value: 'shanghai',
    label: '上海市',
    children: [
      { value: 'huangpu', label: '黄浦区' },
      { value: 'xuhui', label: '徐汇区' },
      { value: 'changning', label: '长宁区' },
      { value: 'jingan', label: '静安区' },
      { value: 'putuo', label: '普陀区' }
    ]
  },
  {
    value: 'guangdong',
    label: '广东省',
    children: [
      { value: 'guangzhou', label: '广州市' },
      { value: 'shenzhen', label: '深圳市' },
      { value: 'zhuhai', label: '珠海市' },
      { value: 'shantou', label: '汕头市' },
      { value: 'foshan', label: '佛山市' }
    ]
  }
]

export default {
  name: 'UserDialog',
  
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    user: {
      type: Object,
      default: null
    },
    mode: {
      type: String,
      default: 'create',
      validator: (value) => ['create', 'edit'].includes(value)
    }
  },
  
  emits: ['update:modelValue', 'success'],
  
  setup(props, { emit }) {
    const visible = ref(false)
    const loading = ref(false)
    const formRef = ref()
    
    // 会员类型选项
    const memberTypes = [
        { value: 'normal', label: '普通会员' },
        { value: 'advanced', label: '高级会员' },
        { value: 'premium', label: '超级会员' }
      ]
    
    // 用户状态选项
    const userStatuses = [
      { value: 'active', label: '活跃' },
      { value: 'inactive', label: '未激活' },
      { value: 'banned', label: '已封禁' }
    ]
    
    // 运动类型选项
    const sportTypes = [
      { value: 'basketball', label: '篮球' },
      { value: 'football', label: '足球' },
      { value: 'running', label: '跑步' },
      { value: 'badminton', label: '羽毛球' },
      { value: 'tennis', label: '网球' },
      { value: 'swimming', label: '游泳' },
      { value: 'yoga', label: '瑜伽' },
      { value: 'cycling', label: '骑行' },
      { value: 'pingpong', label: '乒乓球' },
      { value: 'tabletennis', label: '乒乓球' },
      { value: 'volleyball', label: '排球' },
      { value: 'fishing', label: '钓鱼' }
    ]
    
    // 运动水平选项
    const skillLevels = [
      { value: 'beginner', label: '初学者' },
      { value: 'intermediate', label: '中级' },
      { value: 'advanced', label: '高级' },
      { value: 'professional', label: '专业级' }
    ]
    
    // 可用时间选项
    const availableTimes = [
      { value: 'weekday_morning', label: '工作日早上' },
      { value: 'weekday_afternoon', label: '工作日下午' },
      { value: 'weekday_evening', label: '工作晚上' },
      { value: 'weekend_morning', label: '周末早上' },
      { value: 'weekend_afternoon', label: '周末下午' },
      { value: 'weekend_evening', label: '周末晚上' }
    ]
    
    // 表单数据
    const formData = reactive({
      nickname: '',
      phone: '',
      email: '',
      memberType: 'normal',
      status: 'active',
      gender: 'unknown',
      preferredSports: [],
      skillLevel: 'beginner',
      availableTime: [],
      activityScore: 50,
      createdActivities: 0,
      joinedActivities: 0,
      isRecommended: false,
      remark: '',
      balance: 0,
      points: 0,
      pointsLastUpdate: '',
      honors: [],
      wechatNumber: '' // 添加微信号字段
    })
    
    // 表单验证规则
    const formRules = {
      nickname: [
        { required: true, message: '请输入用户昵称', trigger: 'blur' },
        { min: 2, max: 20, message: '昵称长度在 2 到 20 个字符', trigger: 'blur' }
      ],
      phone: [
        { required: false, message: '请输入手机号码', trigger: 'blur' },
        {
          pattern: /^1[3-9]\d{9}$/,
          message: '请输入正确的手机号码',
          trigger: 'blur'
        }
      ],
      email: [
        { required: false, message: '请输入邮箱地址', trigger: 'blur' },
        {
          pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
          message: '请输入正确的邮箱地址',
          trigger: 'blur'
        }
      ],
      memberType: [
        { required: true, message: '请选择会员类型', trigger: 'change' }
      ],
      status: [
        { required: true, message: '请选择用户状态', trigger: 'change' }
      ],
      gender: [
        { required: true, message: '请选择性别', trigger: 'change' }
      ],
      preferredSports: [
        { required: false, message: '请选择偏好运动', trigger: 'change' }
      ],
      skillLevel: [
        { required: false, message: '请选择运动水平', trigger: 'change' }
      ],
      availableTime: [
        { required: false, message: '请选择可用时间', trigger: 'change' }
      ],
      activityScore: [
        { required: false, message: '请输入活跃度分数', trigger: 'blur' },
        {
          validator: (rule, value, callback) => {
            if (value < 0 || value > 100) {
              callback(new Error('活跃度分数必须在 0-100 之间'))
            } else {
              callback()
            }
          },
          trigger: 'blur'
        }
      ],
      createdActivities: [
        { required: false, message: '请输入创建活动数', trigger: 'blur' },
        {
          validator: (rule, value, callback) => {
            if (value < 0) {
              callback(new Error('创建活动数不能为负数'))
            } else {
              callback()
            }
          },
          trigger: 'blur'
        }
      ],
      joinedActivities: [
        { required: false, message: '请输入参与活动数', trigger: 'blur' },
        {
          validator: (rule, value, callback) => {
            if (value < 0) {
              callback(new Error('参与活动数不能为负数'))
            } else {
              callback()
            }
          },
          trigger: 'blur'
        }
      ],
      remark: [
        { required: false, message: '请输入账号备注', trigger: 'blur' },
        { min: 0, max: 100, message: '备注长度不能超过 100 个字符', trigger: 'blur' }
      ],
      balance: [
        { required: false, message: '请输入用户余额', trigger: 'blur' },
        {
          validator: (rule, value, callback) => {
            if (value < 0) {
              callback(new Error('余额不能为负数'))
            } else if (value > 99999.99) {
              callback(new Error('余额不能超过99999.99元'))
            } else {
              callback()
            }
          },
          trigger: 'blur'
        }
      ]
    }
    
    // 计算属性
    const dialogTitle = computed(() => {
      return props.mode === 'create' ? '创建用户' : '编辑用户'
    })
    
    const dialogWidth = computed(() => {
      return window.innerWidth < 768 ? '90%' : '800px'
    })
    
    // 监听props变化
    watch(() => props.modelValue, (newVal) => {
      console.log('UserDialog modelValue changed:', newVal);
      visible.value = newVal
      if (newVal) {
        initFormData()
      }
    })
    
    watch(visible, (newVal) => {
      console.log('UserDialog visible changed:', newVal);
      emit('update:modelValue', newVal)
      if (!newVal) {
        resetForm()
      }
    })
    
    // 初始化表单数据
    const initFormData = () => {
      console.log('initFormData called, mode:', props.mode, 'user:', props.user);
      nextTick(() => {
        if (props.mode === 'edit' && props.user) {
          console.log('Editing user data:', props.user);
          // 先复制基础属性
          Object.assign(formData, props.user)
          // 手动映射数据库中的下划线命名字段到前端的驼峰命名
          if (props.user.wechat_number) {
            formData.wechatNumber = props.user.wechat_number
          }
          // 获取用户积分和荣誉信息
          getUserPoints(props.user.id)
          getUserHonors(props.user.id)
        } else {
          console.log('Resetting form for create mode');
          resetForm()
        }
      })
    }

    // 格式化日期
    const formatDate = (dateString) => {
      if (!dateString) return ''
      const date = new Date(dateString)
      return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')} ${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`
    }
    
    // 重置表单
    const resetForm = () => {
      if (formRef.value) {
        formRef.value.resetFields()
      }
      Object.assign(formData, {
        nickname: '',
        phone: '',
        email: '',
        memberType: 'normal',
        status: 'active',
        gender: 'unknown',
        preferredSports: [],
        skillLevel: 'beginner',
        availableTime: [],
        activityScore: 50,
        createdActivities: 0,
        joinedActivities: 0,
        isRecommended: false,
        remark: '',
        balance: 0,
        points: 0,
        pointsLastUpdate: '',
        honors: []
      })
    }

    // 获取用户积分信息
    const getUserPoints = async (userId) => {
      try {
        const response = await api.getUserPoints(userId)
        if (response.success) {
          formData.points = response.data.points || 0
          formData.pointsLastUpdate = response.data.lastUpdateTime
        }
      } catch (error) {
        console.error('获取用户积分失败:', error)
      }
    }

    // 获取用户荣誉信息
    const getUserHonors = async (userId) => {
      try {
        const response = await api.getUserHonors(userId)
        if (response.success) {
          formData.honors = response.data || []
        }
      } catch (error) {
        console.error('获取用户荣誉失败:', error)
      }
    }
    
    // 处理表单提交
    const handleSubmit = async () => {
      if (!formRef.value) return
      
      try {
        const valid = await formRef.value.validate()
        if (!valid) return
        
        loading.value = true
        
        // 处理表单数据，确保包含balance字段，并排除points字段（该字段通过单独API管理）
        const { points, pointsLastUpdate, honors, ...filteredFormData } = formData
        const submitData = {
          ...filteredFormData,
          balance: parseFloat(filteredFormData.balance || 0).toFixed(2),
          wechat_number: formData.wechatNumber // 将前端的驼峰命名转换为数据库的下划线命名
        }
        
        console.log('提交用户数据结构:', JSON.stringify(submitData, null, 2))
        console.log('提交用户ID:', props.user.id)
        console.log('提交模式:', props.mode)
        console.log('是否包含手机号:', 'phone' in submitData)
        console.log('是否包含微信号:', 'wechat_number' in submitData)
        
        try {
          if (props.mode === 'create') {
            // 使用专门的createUser方法创建用户
            await api.createUser(submitData)
            ElMessage.success('用户创建成功')
          } else {
            console.log('准备调用updateUser API')
            const response = await api.updateUser(props.user.id, submitData)
            console.log('API调用成功，响应:', response)
            ElMessage.success('用户信息更新成功')
          }
          emit('success')
          handleClose()
        } catch (error) {
          console.error('API调用失败详情:', error)
          console.error('错误响应:', error.response)
          ElMessage.error(error.response?.data?.message || '提交失败，请重试')
        }
      } catch (error) {
        console.error('表单提交失败:', error)
        if (error !== 'cancel') {
          ElMessage.error('提交失败，请检查表单数据')
        }
      } finally {
        loading.value = false
      }
    }
    
    // 处理弹窗关闭
    const handleClose = (done) => {
      if (formRef.value) {
        formRef.value.clearValidate()
      }
      
      // Element Plus Dialog 的 before-close 回调参数是 done 函数
      // 直接点击取消按钮时，done 参数可能是 undefined 或 MouseEvent
      if (typeof done === 'function') {
        done()
      } else {
        visible.value = false
      }
    }
    
    // 自动计算活跃度分数
    const calculateActivityScore = async () => {
      try {
        loading.value = true
        if (!props.user?.id) {
          ElMessage.warning('请先选择要计算分数的用户')
          return
        }
        
        const response = await api.updateUserActivityScore(props.user.id)
        if (response.success) {
          formData.activityScore = response.activityScore
          ElMessage.success(`活跃度分数已更新: ${response.activityScore}`)
        }
      } catch (error) {
        console.error('计算活跃度分数失败:', error)
        ElMessage.error('计算活跃度分数失败')
      } finally {
        loading.value = false
      }
    }
    
    // 获取当前活跃度分数
    const getActivityScore = async () => {
      try {
        if (!props.user?.id) {
          ElMessage.warning('请先选择用户')
          return
        }
        
        const response = await api.getUserActivityScore(props.user.id)
        if (response.success) {
          ElMessage.info(`当前活跃度分数: ${response.activityScore}`)
        }
      } catch (error) {
        console.error('获取活跃度分数失败:', error)
        ElMessage.error('获取活跃度分数失败')
      }
    }
    
    return {
      visible,
      loading,
      formRef,
      formData,
      formRules,
      memberTypes,
      userStatuses,
      sportTypes,
      skillLevels,
      availableTimes,
      dialogTitle,
      dialogWidth,
      
      handleSubmit,
      handleClose,
      calculateActivityScore,
      getActivityScore,
      getUserPoints,
      getUserHonors,
      formatDate
    }
  }
}
</script>

<style scoped>
:deep(.el-dialog) {
  border-radius: 12px;
  overflow: hidden;
}

:deep(.el-dialog__header) {
  background: linear-gradient(135deg, #409eff, #66b1ff);
  margin: 0;
  padding: 16px 20px;
}

:deep(.el-dialog__title) {
  color: white;
  font-weight: 600;
}

:deep(.el-dialog__headerbtn) {
  top: 16px;
}

:deep(.el-dialog__headerbtn .el-dialog__close) {
  color: white;
}

:deep(.el-dialog__body) {
  padding: 20px;
  max-height: 70vh;
  overflow-y: auto;
}

:deep(.el-form-item) {
  margin-bottom: 20px;
}

:deep(.el-form-item__label) {
  font-weight: 500;
  color: #606266;
}

:deep(.el-input__wrapper) {
  border-radius: 6px;
}

:deep(.el-textarea__inner) {
  border-radius: 6px;
  resize: vertical;
}

:deep(.el-select) {
  width: 100%;
}

:deep(.el-date-editor) {
  width: 100%;
}

:deep(.el-input-number) {
  width: 100%;
}

:deep(.el-input-number .el-input__wrapper) {
  padding-left: 30px;
}

.score-text {
  margin-left: 8px;
  color: #606266;
  font-size: 14px;
}

:deep(.el-divider__text) {
  font-size: 14px;
  font-weight: 600;
  color: #409eff;
}

:deep(.el-radio-group) {
  display: flex;
  gap: 20px;
}

:deep(.el-switch) {
  margin-right: 8px;
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

:deep(.el-button) {
  border-radius: 6px;
  font-weight: 500;
  min-width: 80px;
}

:deep(.el-button--primary) {
  background: linear-gradient(135deg, #409eff, #66b1ff);
  border: none;
}

:deep(.el-button--primary:hover) {
  background: linear-gradient(135deg, #66b1ff, #409eff);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(64, 158, 255, 0.4);
}

:deep(.el-button--primary:active) {
  transform: translateY(0);
}

/* 响应式设计 */
@media (max-width: 768px) {
  :deep(.el-dialog) {
    margin: 20px;
    width: auto !important;
  }
  
  :deep(.el-dialog__body) {
    padding: 16px;
    max-height: 60vh;
  }
  
  :deep(.el-form-item) {
    margin-bottom: 16px;
  }
  
  :deep(.el-form-item__label) {
    padding-bottom: 8px;
  }
  
  :deep(.el-row) {
    margin: 0 !important;
  }
  
  :deep(.el-col) {
    padding: 0 !important;
  }
  
  :deep(.el-radio-group) {
    flex-direction: column;
    gap: 12px;
  }
  
  .dialog-footer {
    flex-direction: column;
    gap: 8px;
  }
  
  :deep(.el-button) {
    width: 100%;
    margin: 0;
  }
}

/* 滚动条样式 */
:deep(.el-dialog__body)::-webkit-scrollbar {
  width: 6px;
}

:deep(.el-dialog__body)::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

:deep(.el-dialog__body)::-webkit-scrollbar-thumb {
  background: #c0c4cc;
  border-radius: 3px;
}

:deep(.el-dialog__body)::-webkit-scrollbar-thumb:hover {
  background: #909399;
}

/* 动画效果 */
:deep(.el-dialog) {
  animation: dialogSlideIn 0.3s ease;
}

@keyframes dialogSlideIn {
  from {
    opacity: 0;
    transform: translateY(-20px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

/* 表单聚焦效果 */
:deep(.el-cascader .el-input__wrapper.is-focus) {
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2) !important;
}
</style>